import Cookies from 'js-cookie';

const SESSION_COOKIE = 'adminInfo';
const DASHBOARD_ROLES = new Set(['Admin', 'CEO']);

export const isDashboardAdmin = (value) =>
  Boolean(
    value &&
      typeof value === 'object' &&
      typeof value.token === 'string' &&
      value.token.trim() &&
      typeof value.email === 'string' &&
      value.email.trim() &&
      DASHBOARD_ROLES.has(value.role)
  );

export const clearAdminSession = () => {
  Cookies.remove(SESSION_COOKIE, { path: '/' });
};

export const getAdminSession = () => {
  const serialized = Cookies.get(SESSION_COOKIE);
  if (!serialized) return null;

  try {
    const session = JSON.parse(serialized);
    if (isDashboardAdmin(session)) return session;
  } catch {
    // A malformed client cookie should never crash the dashboard.
  }

  clearAdminSession();
  return null;
};

export const storeAdminSession = (session) => {
  if (!isDashboardAdmin(session)) {
    throw new Error('The server returned an invalid administrator session.');
  }

  Cookies.set(SESSION_COOKIE, JSON.stringify(session), {
    expires: 7,
    path: '/',
    sameSite: 'strict',
    secure:
      typeof window !== 'undefined' && window.location.protocol === 'https:',
  });
};
